<template>
  <section class="content-block">
    <div id="checkoutIframe" />
  </section>
</template>

<script>

export default {
  name: 'Checkout',
  data() {
    return {
      checkout_link: this.$store.state.checkout_link
    }
  },
  mounted() {
    const iframeUrl = this.checkout_link + '?language=' + this.$t('general.settings.currentLanguageCode');
    const initIframe = (i, n, c, e, r, t, s, h) => {
      i[e] = i[e] || function () {
        (i[e].q = i[e].q || []).push([].slice.call(arguments))
      }
      this.$store.state.iframeScript = n.createElement(c);
      this.$store.state.iframeScript.src = r;
      this.$store.state.iframeScript.onload = function () {
        // eslint-disable-next-line no-undef
        IncertClass.n = e;
        // eslint-disable-next-line no-undef
        incertIframe(t, s, h);
      }
      n.head.appendChild(this.$store.state.iframeScript);
    }

    if (this.$store.state.iframeScript) {
      // eslint-disable-next-line no-undef
      window.removeEventListener("message", Incert.processMessage);
      this.$store.state.iframeScript.parentNode.removeChild(this.$store.state.iframeScript);
      this.$store.state.iframeScript = null;
      delete window["inc"];
      // eslint-disable-next-line no-undef
      Incert = undefined;
      // eslint-disable-next-line no-undef
      IncertClass = undefined;
      // eslint-disable-next-line no-undef
      incertIframe = undefined;
    }
    initIframe(window, document, "SCRIPT", "inc",
      "https://myincert.com/public/api/incertClient.js", "checkoutIframe", iframeUrl, '');

  }
}
</script>

<style scoped lang="scss">
.marker {
  width: 100%;
  position: relative;
  display: block;
  text-align: center;

  .line {
    width: 100%;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }

  .subtitle {
    width: 100px;
    position: absolute;
    top: -0.55rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
    color: rgba(180, 180, 180, 1);
    background-color: rgba(255, 255, 255, 1);
  }
}

@media (max-width: 680px) {
  .marker {
    .subtitle {
      top: -0.35rem;
    }
  }
}
</style>
